import { AfterContentInit, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nw-dom-content',
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
})
export class DomContentComponent implements AfterContentInit {
  ngAfterContentInit(): void {
    document.dispatchEvent(new Event('DOMContentLoaded'));
  }
}
